import React from "react";

const Banner = () => {
    return (
        <section className="banner">
            <span>join us</span>
            <h3 className="banner__title">get up to 50% discount</h3>
            <p className="banner__description">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat architecto nesciunt aut sapiente quis inventore quam vitae quod illum incidunt.
            </p>
            <a href="#home" className="button">get disount</a>
        </section>
    )
}

export default Banner;